import type { ReactNode } from 'react';
import { Icon, Logo } from '@/components/foundations';

export type AuthLayoutProps = {
  /** Frase da coluna da marca. */
  headline?: ReactNode;
  /** Selo acima do formulário (ex.: "Ambiente de teste"). */
  badge?: ReactNode;
  children: ReactNode;
};

/** Login em duas colunas (`.auth`): marca à esquerda, formulário à direita. */
export function AuthLayout({ headline = <>Pagamentos simples<br />para o seu negócio.</>, badge, children }: AuthLayoutProps) {
  return (
    <div className="auth">
      <section className="auth-brand">
        <svg className="deco" viewBox="0 0 800 1000" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
<g fill="none" stroke="#dbe5f7" strokeWidth="1">
<path d="M290 0 520 230 790 -10" /><path d="M0 660C90 640 190 740 190 880V1000" /><path d="M300 1000C290 880 360 780 450 700L580 540 800 770" /><path d="M0 330 230 560" />
</g>
<g fill="#e9f0fc"><rect x="370" y="-110" width="300" height="250" rx="60" transform="rotate(45 520 15)" opacity=".7" /><rect x="-170" y="300" width="360" height="340" rx="70" transform="rotate(45 10 470)" opacity=".7" /><rect x="215" y="720" width="640" height="500" rx="150" transform="rotate(45 535 970)" opacity=".8" /><rect x="-110" y="790" width="240" height="240" rx="50" transform="rotate(45 10 910)" opacity=".7" /></g>
<g fill="#d3e0f7"><circle cx="455" cy="635" r="5" /><circle cx="148" cy="742" r="6" /></g>
<g fill="#dfe7f5"><circle cx="620" cy="122" r="2.5" /><circle cx="642" cy="122" r="2.5" /><circle cx="665" cy="122" r="2.5" /><circle cx="620" cy="147" r="2.5" /><circle cx="642" cy="147" r="2.5" /><circle cx="665" cy="147" r="2.5" /><circle cx="620" cy="172" r="2.5" /><circle cx="642" cy="172" r="2.5" /><circle cx="665" cy="172" r="2.5" /><circle cx="620" cy="197" r="2.5" /><circle cx="642" cy="197" r="2.5" /><circle cx="665" cy="197" r="2.5" /><circle cx="620" cy="219" r="2.5" /><circle cx="642" cy="219" r="2.5" /><circle cx="665" cy="219" r="2.5" fill="#4a7bd9" /></g></svg>
        <div className="in"><Logo size="lg" id="lg2" /><h1>{headline}</h1><div className="bar"></div></div>
      </section>
      <section className="auth-form">
        {badge && <span className="env"><Icon name="flask" />{badge}</span>}
        {children}
      </section>
    </div>
  );
}
